__webpack_require__.p = "https://app.groovehqstaging.com/app-release/";